module.exports = __webpack_public_path__ + "img/ladybug.be5030ca.webp";